/**
 * External Dependencies
 */
import 'jquery';
import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';

import {Splide} from '@splidejs/splide';
import {Grid} from '@splidejs/splide-extension-grid';
import communicationWidget from './custom/comwidget';
import loadMoreNews from './custom/loadmorenews';
import loadNewsByCategory from './custom/loadnewsbycategory';
import loadMap from "./custom/loadmap";
import ApplicationHandler from "./custom/application";

window.Alpine = Alpine;

Alpine.start();

communicationWidget();
loadMoreNews();
loadNewsByCategory();

window.loadMap = loadMap;

new ApplicationHandler(
    '.application-form--wrapper',
    '#application-form',
    'button[type="submit"]',
    '#files'
);

document.addEventListener('DOMContentLoaded', () => {
    /* Mounting all Splidejs sliders */
    const splides = document.getElementsByClassName('splide');

    if (splides.length > 0) {
        for (let i = 0; i < splides.length; i++) {
            if(splides[i].parentNode.classList.contains('mapmodule')) {
                if(splides[i].parentNode.dataset.synced !== 'true') {
                    let sliderParent = splides[i].parentNode;
                    sliderParent.dataset.synced = 'true';

                    let primary_slider = sliderParent.querySelector('.splide--primary');
                    let secondary_slider = sliderParent.querySelector('.splide--secondary');

                    if(primary_slider && secondary_slider) {
                        let primary = new Splide(primary_slider);
                        let secondary = new Splide(secondary_slider);

                        primary.sync(secondary);
                        primary.mount();
                        secondary.mount();
                    }
                }
            } else {
                if(!splides[i].parentNode.classList.contains('clientscroller')) {
                    new Splide(splides[i]).mount();
                } else {
                    // ToDo: better differentiate Sliders w/o Grid extension
                    new Splide(splides[i]).mount({Grid});
                }
            }
        }
    }
});
